import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import ScheduleMNGChart from "./ScheduleMNGChart";
import ScheduleMNGHours from "./ScheduleMNGHours";
import {
  dayFactHours,
  employeeMonthTotals,
  formatMngHours,
  lunchHoursFromShiftHours,
  shiftLunchHours,
  shiftWorkedHours,
  sumFactHours,
} from "./mngHours";
import { employeeScheduleWarnings } from "./mngRules";
import ScheduleChkApprove from "../scheduleChk/ScheduleChkApprove";
import { GetScheduleMNG } from "../../api/schedule_mng";
import { Me } from "../../api/users";
import { PostGet } from "../../api/post";
import { CreateMNGShifts, DeleteShift, DeleteShifts } from "../../api/mng_shift";
import { OpentypeShiftGet } from "../../api/type_shift";
import { GetApprove, Approve } from "../../api/approved_mng";
import { GetReportMNG } from "../../api/report";
import { MNGLevel, MngGroupLevels } from "../../constants";

const ScheduleMNG = ({ token }) => {
  const [user, setUser] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [tableSchedule, setTableSchedule] = useState();
  const [addForm, setAddForm] = useState({
    name: "",
    start: 0,
    end: 0,
    userId: 0,
    date: "",
    endDate: "",
    index: 0,
    typeShiftId: 1,
  });
  const [deleteForm, setDeleteForm] = useState({ MNGShiftId: 0, userId: 0 });
  const [infoMessage, setInfoMessage] = useState("");
  const [openTypeShiftList, setOpenTypeShiftList] = useState([]);
  const [haveShiftOrNo, setHaveShiftOrNo] = useState(true);
  const [downloadStart, setDownloadStart] = useState(
    getFormattedMonthDates(new Date().toISOString().split("T")[0])[0],
  );
  const [downloadEnd, setDownloadEnd] = useState(
    getFormattedMonthDates(new Date().toISOString().split("T")[0])[1],
  );
  const [downloading, setDownloading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState(null);

  const [dataApprove, setDataApprove] = useState();
  const [arrayDate, setArrayDate] = useState(
    getFormattedMonthDates(new Date().toISOString().split("T")[0]),
  );
  const [accessLevelUser, setAccessLevelUser] = useState();

  const NameShift = [
    "МС",
    "МР",
    "Инвен",
    "Пипл",
    "Админ",
    "Командировка",
    "Собрание",
    "Офис",
    "В другом ресторане",
  ];

  const [normaHours, setNormaHours] = useState(
    new Date().getMonth() === 1 ? 148 : 165,
  );

  const [activeTab, setActiveTab] = useState("schedule");
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [scheduleLoaded, setScheduleLoaded] = useState(false);
  const [monthPickerDate, setMonthPickerDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [selectMode, setSelectMode] = useState(false);
  const [selectedShifts, setSelectedShifts] = useState({});
  const [confirmBulkDelete, setConfirmBulkDelete] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  const [bulkMessage, setBulkMessage] = useState(null);
  const [creating, setCreating] = useState(false);

  const loadTypeShift = async () => {
    try {
      const response = await Me(token);
      setUser(response);
      const post = await PostGet(token, response.post_id);
      setAccessLevelUser(post.access_level);

      const statusShits = await OpentypeShiftGet(token);
      setOpenTypeShiftList(statusShits);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadTypeShift();
  }, [token]);

  useEffect(() => {
    if (token && user) {
      getScheduleMNG();
    }
  }, [token, user]);

  useEffect(() => {
    if (!arrayDate[0]) return;
    setDownloadStart(arrayDate[0]);
    setDownloadEnd(arrayDate.at(-1) || arrayDate[0]);
    setDownloadMessage(null);
  }, [arrayDate]);

  function getMngShiftTypeName(shift) {
    if (shift?.type_shift_name) {
      return shift.type_shift_name;
    }
    for (let tp of openTypeShiftList) {
      if (tp.id == shift.type_shift_id) {
        return tp.name;
      }
    }
    return "";
  }

  function getMngShiftCellClass(shift) {
    if (!shift) return "shift-cell--mng-status";
    const typeId = Number(shift.type_shift_id);
    if (typeId === 1) return getMngShiftNameCellClass(shift);
    return "shift-cell--mng-status";
  }

  function getMngShiftNameCellClass(shift) {
    const classByName = {
      Админ: "shift-cell--mng-admin",
      Пипл: "shift-cell--mng-pipl",
      Инвен: "shift-cell--mng-inven",
      МС: "shift-cell--mng-shift",
      МР: "shift-cell--mng-mr",
      Командировка: "shift-cell--mng-trip",
      Собрание: "shift-cell--mng-meeting",
      "Собрание и Офис": "shift-cell--mng-meeting",
      Офис: "shift-cell--mng-office",
      "В другом ресторане": "shift-cell--mng-other",
    };
    return classByName[shift?.name] || "shift-cell--mng-shift";
  }

  function calculateMngShiftHours(start, end) {
    const startNum = Number(start);
    const endNum = Number(end);
    if (Number.isNaN(startNum) || Number.isNaN(endNum)) {
      return NaN;
    }
    if (startNum > endNum) {
      return 24 - startNum + endNum;
    }
    return endNum - startNum;
  }

  function validateNameShiftDuration() {
    if (!NameShift.includes(addForm.name) || addForm.typeShiftId !== 1) {
      return null;
    }
    const hours = calculateMngShiftHours(addForm.start, addForm.end);
    if (Number.isNaN(hours) || hours < 1) {
      return "Для смены из списка (МС, МР, Инвен и др.) длительность должна быть не менее 1 часа";
    }
    return null;
  }

  function switchTab(tab) {
    setActiveTab(tab);
    if (tab === "schedule" && !scheduleLoaded) getScheduleMNG();
    if (tab === "approve" && !Number.isFinite(dataApprove?.id)) loadAppored();
  }

  function selectDate(event) {
    const date = event.target.value;
    setMonthPickerDate(date);
    const selectDateInput = new Date(event.target.value);
    if (selectDateInput.getMonth() == 1) {
      setNormaHours(148);
    } else {
      setNormaHours(165);
    }
    setArrayDate(getFormattedMonthDates(selectDateInput));
    setSelectedDate(date);
    setScheduleLoaded(false);
    setTableSchedule(undefined);
    setDataApprove(undefined);
    setSelectMode(false);
    setSelectedShifts({});
    setConfirmBulkDelete(false);
    setBulkMessage(null);

    if (activeTab === "schedule") {
      getScheduleMNG(date);
    } else if (activeTab === "approve") {
      const monthDates = getFormattedMonthDates(selectDateInput);
      loadAppored(monthDates[0], monthDates.at(-1));
    }
  }

  async function getScheduleMNG(overrideDate) {
    const date = overrideDate ?? selectedDate;
    if (!user) return;
    if (!overrideDate && (scheduleLoaded || isLoadingSchedule)) return;

    setIsLoadingSchedule(true);
    try {
      const data = await GetScheduleMNG(token, date, user.restaurant_id);
      setTableSchedule(data);
      setScheduleLoaded(true);
      if (overrideDate) {
        setSelectedDate(date);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSchedule(false);
    }
  }

  async function haveShift(shift, dayIndex, employee) {
    setHaveShiftOrNo(true);
    setDeleteForm({
      MNGShiftId: shift.id,
      userId: shift.user_id,
      index: dayIndex,
      shift: shift,
      factHours: dayFactHours(employee, dayIndex - 1),
    });
    setInfoMessage("");
  }

  function notHaveShift(employee, index, date) {
    setHaveShiftOrNo(false);
    setAddForm({
      ...addForm,
      userId: employee.user_id,
      date,
      endDate: date,
      index: index,
    });
    setInfoMessage("");
  }

  function canDeleteMngShift(shift) {
    return Boolean(shift?.id) && toIsoDate(shift.date) >= todayLocalIso();
  }

  function toggleSelectMode() {
    setSelectMode((prev) => {
      if (prev) {
        setSelectedShifts({});
        setConfirmBulkDelete(false);
        setBulkMessage(null);
        return false;
      }
      return true;
    });
  }

  function clearSelection() {
    setSelectedShifts({});
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function toggleSelectedShift(shift, dayIndex) {
    if (!canDeleteMngShift(shift)) return;
    setSelectedShifts((prev) => {
      const next = { ...prev };
      if (next[shift.id]) {
        delete next[shift.id];
      } else {
        next[shift.id] = { userId: shift.user_id, dayIndex };
      }
      return next;
    });
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function collectDeletableShifts(predicate) {
    const next = {};
    (tableSchedule?.table || []).forEach((employee) => {
      (employee.shifts || []).forEach((shift, dayIndex) => {
        if (!predicate(shift, employee, dayIndex)) return;
        if (!canDeleteMngShift(shift)) return;
        next[shift.id] = { userId: employee.user_id, dayIndex: dayIndex + 1 };
      });
    });
    return next;
  }

  function toggleGroup(nextGroup) {
    const ids = Object.keys(nextGroup);
    if (ids.length === 0) return;
    const allSelected = ids.every((id) => selectedShifts[id]);
    setSelectedShifts((prev) => {
      if (allSelected) {
        const next = { ...prev };
        ids.forEach((id) => {
          delete next[id];
        });
        return next;
      }
      return { ...prev, ...nextGroup };
    });
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function toggleDayColumn(dayIndex) {
    toggleGroup(
      collectDeletableShifts(
        (_shift, _employee, index) => index === dayIndex,
      ),
    );
  }

  function toggleEmployeeRow(employee) {
    toggleGroup(
      collectDeletableShifts(
        (_shift, row) => row.user_id === employee.user_id,
      ),
    );
  }

  function handleShiftClick(event, shift, dayIndex, employee) {
    if (selectMode) {
      event.preventDefault();
      event.stopPropagation();
      if (shift) toggleSelectedShift(shift, dayIndex + 1);
      return;
    }
    if (shift) {
      haveShift(shift, dayIndex + 1, employee);
      return;
    }
    const selectedDateDate = new Date(selectedDate);
    notHaveShift(
      employee,
      dayIndex + 1,
      formatDate(
        new Date(
          selectedDateDate.getFullYear(),
          selectedDateDate.getMonth(),
          dayIndex + 1,
        ),
      ),
    );
  }

  function renderScheduleTable() {
    const data = tableSchedule;
    if (!data?.table) return null;

    const selectedDateDate = new Date(selectedDate);
    const year = selectedDateDate.getFullYear();
    const month = selectedDateDate.getMonth();
    const daysInMonth = data.days || new Date(year, month + 1, 0).getDate();
    const weekDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
    const modalBind = selectMode
      ? {}
      : { "data-bs-toggle": "modal", "data-bs-target": "#staticBackdrop" };

    const firstRow = [
      <th key="position" rowSpan={2} className="schedule-mng-sticky-col schedule-mng-post-col text-center">
        Должность
      </th>,
      <th
        key="name"
        rowSpan={2}
        className="schedule-mng-sticky-col text-center"
        style={{ left: "80px" }}
      >
        Фамилия Имя
      </th>,
    ];
    const secondRow = [];

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      const dayOfWeek = currentDate.getDay();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
      const headerClass = `text-center ${isWeekend ? "schedule-mng-day-header--weekend" : ""} ${
        selectMode ? "schedule-mng-select-head" : ""
      }`;

      firstRow.push(
        <th
          key={`day-${day}`}
          className={headerClass}
          title={selectMode ? "Выделить все смены этого дня" : undefined}
          onClick={selectMode ? () => toggleDayColumn(day - 1) : undefined}
        >
          {day}
        </th>,
      );

      secondRow.push(
        <th
          key={`weekday-${day}`}
          className={`text-center ${isWeekend ? "schedule-mng-weekday--weekend" : ""} ${
            selectMode ? "schedule-mng-select-head" : ""
          }`}
          style={{ fontSize: "12px" }}
          title={selectMode ? "Выделить все смены этого дня" : undefined}
          onClick={selectMode ? () => toggleDayColumn(day - 1) : undefined}
        >
          {weekDays[dayOfWeek]}
        </th>,
      );
    }

    firstRow.push(
      <th
        key="month-hours"
        rowSpan={2}
        className="text-center schedule-mng-total-col"
      >
        Часы
      </th>,
      <th
        key="month-fact"
        rowSpan={2}
        className="text-center schedule-mng-total-col"
      >
        Факт
      </th>,
      <th
        key="month-lunch"
        rowSpan={2}
        className="text-center schedule-mng-total-col"
      >
        Обеды
      </th>,
      <th
        key="month-norma"
        rowSpan={2}
        className="text-center schedule-mng-total-col"
      >
        Норма
      </th>,
      <th
        key="month-target"
        rowSpan={2}
        className="text-center schedule-mng-total-col"
      >
        Норма+обеды
      </th>,
    );

    const renderShift = (shift, dayIndex, employee, ruleWarning) => {
      const isSelected = Boolean(shift?.id && selectedShifts[shift.id]);
      const canSelect = Boolean(shift && canDeleteMngShift(shift));
      const factHours = dayFactHours(employee, dayIndex);
      const factLine =
        factHours > 0 ? (
          <div className="shift-mng-cell-fact">
            факт {formatMngHours(factHours)}
          </div>
        ) : null;
      const cellClass = [
        "shift-cell",
        "text-center",
        shift
          ? Number(shift.type_shift_id) !== 1
            ? getMngShiftCellClass(shift)
            : getMngShiftNameCellClass(shift)
          : "shift-cell--off",
        isSelected ? "is-selected" : "",
        selectMode && shift && !canSelect ? "is-locked" : "",
        ruleWarning ? "is-rule-streak" : "",
      ]
        .filter(Boolean)
        .join(" ");

      let body = factLine || "—";
      if (shift) {
        if (Number(shift.type_shift_id) !== 1) {
          body = (
            <>
              <div>{getMngShiftTypeName(shift)}</div>
              {factLine}
            </>
          );
        } else {
          body = (
            <>
              <div className="shift-mng-cell-name">{shift.name}</div>
              <div>
                {shift.start}-{shift.end}
              </div>
              {shift.hours > 0 && (
                <div className="shift-mng-cell-hours">
                  {formatMngHours(shiftWorkedHours(shift), 2)} ч
                </div>
              )}
              {factLine}
            </>
          );
        }
      }

      return (
        <td
          key={`shift-${employee.user_id}-${dayIndex}`}
          className={cellClass}
          title={ruleWarning || undefined}
          {...(!selectMode ? modalBind : {})}
        >
          <div
            className="shift-cell-clickable"
            onClick={(event) =>
              handleShiftClick(event, shift, dayIndex, employee)
            }
          >
            {body}
          </div>
        </td>
      );
    };

    const tbody = data.table.map((employee, empIndex) => {
      const month = employeeMonthTotals(employee.shifts, normaHours);
      const factTotal = sumFactHours(employee.fact_hours);
      const ruleWarnings = employeeScheduleWarnings(employee.shifts);
      return (
        <tr key={`emp-${employee.user_id}-${empIndex}`}>
          <td className="schedule-mng-sticky-col text-center fw-semibold">
            {employee.post_name}
          </td>
          <td
            className={`schedule-mng-sticky-col text-center ${
              selectMode ? "schedule-mng-select-head" : ""
            }`}
            style={{ left: "80px" }}
            title={selectMode ? "Выделить все смены сотрудника" : undefined}
            onClick={selectMode ? () => toggleEmployeeRow(employee) : undefined}
          >
            <div className="employee-name">
              {employee.surname} {employee.name}
            </div>
          </td>
          {employee.shifts.map((shift, dayIndex) =>
            renderShift(shift, dayIndex, employee, ruleWarnings[dayIndex]),
          )}
          <td className="text-center schedule-mng-total-col schedule-mng-total-hours">
            {formatMngHours(month.hours)}
          </td>
          <td className="text-center schedule-mng-total-col schedule-mng-total-fact">
            {formatMngHours(factTotal)}
          </td>
          <td className="text-center schedule-mng-total-col">
            {formatMngHours(month.lunch, 2)}
          </td>
          <td className="text-center schedule-mng-total-col">
            {formatMngHours(month.norma)}
          </td>
          <td className="text-center schedule-mng-total-col schedule-mng-total-target">
            {formatMngHours(month.target, 2)}
          </td>
        </tr>
      );
    });

    return (
      <div className="table-responsive schedule-mng-table-wrap">
        <table className="table table-bordered table-hover schedule-chk-table">
          <thead>
            <tr key="row1">{firstRow}</tr>
            <tr key="row2">{secondRow}</tr>
          </thead>
          <tbody>{tbody}</tbody>
        </table>
      </div>
    );
  }

  function applyShiftUpdate(schedule, userId, dayIndex, shift) {
    return {
      ...schedule,
      table: schedule.table.map((user) => {
        if (user.user_id != userId) {
          return user;
        }
        const updatedShifts = [...user.shifts];
        updatedShifts[dayIndex - 1] = shift;
        return { ...user, shifts: updatedShifts };
      }),
    };
  }

  function applyShiftsCreate(schedule, userId, shifts) {
    if (!schedule?.table) return schedule;
    const view = parseIso(selectedDate);
    return {
      ...schedule,
      table: schedule.table.map((user) => {
        if (user.user_id != userId) return user;
        const updatedShifts = [...user.shifts];
        shifts.forEach((shift) => {
          const parsed = parseIso(shift.date);
          if (
            !parsed ||
            !view ||
            parsed.year !== view.year ||
            parsed.month !== view.month
          ) {
            return;
          }
          updatedShifts[parsed.day - 1] = shift;
        });
        return { ...user, shifts: updatedShifts };
      }),
    };
  }

  function setRangeDays(days) {
    if (!addForm.date) return;
    setAddForm({
      ...addForm,
      endDate: addDaysIso(addForm.date, days - 1),
    });
  }

  function setRangeToMonthEnd() {
    const start = parseIso(addForm.date);
    if (!start) return;
    const last = new Date(start.year, start.month + 1, 0);
    setAddForm({ ...addForm, endDate: formatDate(last) });
  }

  function getRangePreview() {
    const startDate = addForm.date;
    const endDate = addForm.endDate || addForm.date;
    const dates = eachIsoDate(startDate, endDate);
    const employee = tableSchedule?.table?.find(
      (row) => row.user_id == addForm.userId,
    );
    const view = parseIso(selectedDate);
    const today = todayLocalIso();
    let free = 0;
    let busy = 0;
    let past = 0;
    let otherMonth = 0;
    dates.forEach((iso) => {
      if (iso < today) {
        past += 1;
        return;
      }
      const parsed = parseIso(iso);
      if (
        !employee ||
        !view ||
        !parsed ||
        parsed.year !== view.year ||
        parsed.month !== view.month
      ) {
        otherMonth += 1;
        return;
      }
      if (employee.shifts[parsed.day - 1]) busy += 1;
      else free += 1;
    });
    return { total: dates.length, free, busy, past, otherMonth };
  }

  function getCreateButtonLabel() {
    if (creating) return "Сохранение…";
    const preview = getRangePreview();
    if (preview.total <= 1) return "Сохранить";
    const count = preview.free + preview.otherMonth;
    return `Проставить ${count || preview.total} дн.`;
  }

  async function createShift() {
    const validationError = validateNameShiftDuration();
    if (validationError) {
      setInfoMessage(<div style={{ color: "red" }}>{validationError}</div>);
      return;
    }
    if (!addForm.date) {
      setInfoMessage(<div style={{ color: "red" }}>Выберите дату</div>);
      return;
    }
    const endDate = addForm.endDate || addForm.date;
    if (endDate < addForm.date) {
      setInfoMessage(
        <div style={{ color: "red" }}>Конец периода раньше начала</div>,
      );
      return;
    }
    setCreating(true);
    try {
      const isStatusDay = Number(addForm.typeShiftId) > 1;
      const data = await CreateMNGShifts(
        token,
        addForm.userId,
        addForm.date,
        endDate,
        isStatusDay ? 0 : addForm.start,
        isStatusDay ? 0 : addForm.end,
        isStatusDay ? "" : addForm.name,
        addForm.typeShiftId,
      );
      if (!data || data.detail) {
        setInfoMessage(
          <div style={{ color: "red" }}>
            {errorText(data, "Не удалось сохранить")}
          </div>,
        );
        return;
      }
      const created = Array.isArray(data.created) ? data.created : [];
      const skipped = Array.isArray(data.skipped) ? data.skipped : [];
      if (created.length) {
        setTableSchedule((prev) =>
          applyShiftsCreate(prev, addForm.userId, created),
        );
        if (created.length === 1) {
          const day = parseIso(created[0].date)?.day || addForm.index;
          setDeleteForm({
            MNGShiftId: created[0].id,
            userId: created[0].user_id,
            index: day,
          });
        }
      }
      const parts = [];
      if (created.length) {
        parts.push(
          created.length === 1
            ? "Проставлен 1 день"
            : `Проставлено ${created.length} дней`,
        );
      }
      if (skipped.length) {
        parts.push(`${skipped.length} пропущены`);
      }
      setInfoMessage(
        <div style={{ color: created.length ? "green" : "red" }}>
          {parts.join(". ") || "Нечего проставлять"}
        </div>,
      );
    } catch (err) {
      console.error(err);
      setInfoMessage(
        <div style={{ color: "red" }}>Не удалось сохранить</div>,
      );
    } finally {
      setCreating(false);
    }
  }

  async function deleteShift() {
    const data = await DeleteShift(token, deleteForm.MNGShiftId);
    if (data.detail) {
      setInfoMessage(<div style={{ color: "red" }}>{data.detail}</div>);
      return;
    }
    const updatedTableSchedule = applyShiftUpdate(
      tableSchedule,
      deleteForm.userId,
      deleteForm.index,
      null,
    );
    setAddForm({
      ...addForm,
      userId: data.user_id,
      date: data.date,
      index: deleteForm.index,
    });
    setInfoMessage(<div style={{ color: "green" }}>Удалено!</div>);
    setTableSchedule(updatedTableSchedule);
  }

  function applyShiftsDelete(schedule, deleted) {
    if (!schedule?.table) return schedule;
    const byUser = {};
    Object.values(deleted).forEach(({ userId, dayIndex }) => {
      if (!byUser[userId]) byUser[userId] = [];
      byUser[userId].push(dayIndex);
    });
    return {
      ...schedule,
      table: schedule.table.map((user) => {
        const days = byUser[user.user_id];
        if (!days) return user;
        const updatedShifts = [...user.shifts];
        days.forEach((dayIndex) => {
          updatedShifts[dayIndex - 1] = null;
        });
        return { ...user, shifts: updatedShifts };
      }),
    };
  }

  async function deleteSelectedShifts() {
    const ids = Object.keys(selectedShifts).map(Number);
    if (ids.length === 0) return;
    setBulkDeleting(true);
    setBulkMessage(null);
    try {
      const data = await DeleteShifts(token, ids);
      if (!data || data.detail) {
        setBulkMessage({
          ok: false,
          text: errorText(data, "Не удалось удалить смены"),
        });
        return;
      }
      const deletedIds = Array.isArray(data?.deleted_ids) ? data.deleted_ids : [];
      const skipped = Array.isArray(data?.skipped) ? data.skipped : [];
      const applied = {};
      deletedIds.forEach((id) => {
        if (selectedShifts[id]) applied[id] = selectedShifts[id];
      });
      if (deletedIds.length) {
        setTableSchedule((prev) => applyShiftsDelete(prev, applied));
      }
      const skippedPast = skipped.filter((item) =>
        String(item.reason || "").includes("прошлой"),
      ).length;
      const otherSkipped = skipped.length - skippedPast;
      const parts = [];
      if (deletedIds.length) {
        parts.push(
          deletedIds.length === 1
            ? "Удалена 1 смена"
            : `Удалено ${deletedIds.length} смен`,
        );
      }
      if (skippedPast) {
        parts.push(`${skippedPast} с прошедшей датой пропущены`);
      }
      if (otherSkipped) {
        parts.push(`${otherSkipped} не удалось удалить`);
      }
      setBulkMessage({
        ok: deletedIds.length > 0,
        text: parts.join(". ") || "Нечего удалять",
      });
      setSelectedShifts({});
      setConfirmBulkDelete(false);
    } catch (err) {
      console.error(err);
      setBulkMessage({ ok: false, text: "Не удалось удалить смены" });
    } finally {
      setBulkDeleting(false);
    }
  }

  const getEmployee = (userId) =>
    tableSchedule?.table?.find((row) => row.user_id == userId);

  const getEmployeeLabel = (userId) => {
    const employee = getEmployee(userId);
    if (employee) {
      return `${employee.surname} ${employee.name}`;
    }
    return userId;
  };

  const getEmployeeInitials = (userId) => {
    const employee = getEmployee(userId);
    const surname = String(employee?.surname || "").trim();
    const name = String(employee?.name || "").trim();
    return `${surname.charAt(0)}${name.charAt(0)}`.toUpperCase() || "•";
  };

  const renderPersonCard = (userId, meta) => (
    <div className="schedule-mng-person">
      <span className="schedule-mng-person-mark">
        {getEmployeeInitials(userId)}
      </span>
      <div className="schedule-mng-person-copy">
        <strong>{getEmployeeLabel(userId)}</strong>
        {getEmployee(userId)?.post_name ? (
          <span>{getEmployee(userId).post_name}</span>
        ) : null}
      </div>
      {meta ? <em className="schedule-mng-person-meta">{meta}</em> : null}
    </div>
  );

  function renderFactDetail(shift) {
    const factHours = Number(deleteForm.factHours) || 0;
    if (factHours > 0) {
      return (
        <div className="schedule-mng-detail">
          <span>Факт</span>
          <strong>{formatMngHours(factHours)}</strong>
        </div>
      );
    }
    if (shift?.bk_hours) {
      return (
        <div className="schedule-mng-detail">
          <span>БК часы</span>
          <strong>{shift.bk_hours}</strong>
        </div>
      );
    }
    return null;
  }

  function renderModalHaveShift(shift) {
    if (!shift) {
      return;
    }
    const factDetail = renderFactDetail(shift);
    let details;
    if (shift.type_shift_id == 1) {
      details = (
        <>
          <div className="schedule-mng-detail">
            <span>Смена</span>
            <strong>{shift.name || "Без названия"}</strong>
          </div>
          <div className="schedule-mng-detail">
            <span>Время</span>
            <strong>
              {shift.start} — {shift.end}
            </strong>
          </div>
          <div className="schedule-mng-detail">
            <span>Часов</span>
            <strong>{formatMngHours(shiftWorkedHours(shift), 2)}</strong>
          </div>
          <div className="schedule-mng-detail">
            <span>Обед</span>
            <strong>{formatMngHours(shiftLunchHours(shift), 2)}</strong>
          </div>
          {factDetail}
        </>
      );
    } else if (shift.type_shift_id > 1) {
      let nameTypeShift;
      for (let typeShift of openTypeShiftList) {
        if (typeShift.id == shift.type_shift_id) {
          nameTypeShift = typeShift.name;
        }
      }
      details = (
        <>
          <div className="schedule-mng-detail">
            <span>Статус дня</span>
            <strong>{nameTypeShift || "Статус"}</strong>
          </div>
          {factDetail}
        </>
      );
    }
    return (
      <>
        {renderPersonCard(shift.user_id, formatShortDate(shift.date))}
        <p className="schedule-mng-modal-date">
          {formatMngDisplayDate(shift.date)}
        </p>
        <div className="schedule-mng-details">{details}</div>
      </>
    );
  }

  const renderCreateShiftContext = () => {
    const endDate = addForm.endDate || addForm.date;
    const isRange = Boolean(endDate && endDate !== addForm.date);
    return renderPersonCard(
      addForm.userId,
      isRange
        ? `${formatShortDate(addForm.date)} — ${formatShortDate(endDate)}`
        : formatShortDate(addForm.date),
    );
  };

  const renderAddShiftForm = () => {
    const isStatusDay = Number(addForm.typeShiftId) > 1;
    const preview = getRangePreview();
    const endDate = addForm.endDate || addForm.date;
    const toCreate = preview.free + preview.otherMonth;
    const duration = isStatusDay
      ? NaN
      : calculateMngShiftHours(addForm.start, addForm.end);
    const lunchPreview =
      Number.isFinite(duration) && duration >= 1
        ? lunchHoursFromShiftHours(duration)
        : null;
    return (
      <>
        <div className="schedule-mng-mode" role="tablist">
          <button
            type="button"
            className={!isStatusDay ? "is-active" : ""}
            onClick={() => setAddForm({ ...addForm, typeShiftId: 1 })}
          >
            Смена
          </button>
          <button
            type="button"
            className={isStatusDay ? "is-active" : ""}
            onClick={() => {
              if (isStatusDay) return;
              const firstId = openTypeShiftList[0]?.id;
              if (firstId) {
                setAddForm({ ...addForm, typeShiftId: firstId });
              }
            }}
          >
            Статус
          </button>
        </div>

        {isStatusDay ? (
          <div className="schedule-mng-field">
            <span className="form-label">Какой статус</span>
            <div className="schedule-mng-name-chips">
              {openTypeShiftList.map((shift) => (
                <button
                  key={shift.id}
                  type="button"
                  className={`schedule-mng-range-chip${
                    Number(addForm.typeShiftId) === Number(shift.id)
                      ? " is-active"
                      : ""
                  }`}
                  onClick={() =>
                    setAddForm({
                      ...addForm,
                      typeShiftId: Number(shift.id),
                    })
                  }
                >
                  {shift.name}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="schedule-mng-field">
              <span className="form-label">Название</span>
              <div className="schedule-mng-name-chips">
                {NameShift.map((shift) => (
                  <button
                    key={shift}
                    type="button"
                    className={`schedule-mng-range-chip${
                      addForm.name === shift ? " is-active" : ""
                    }`}
                    onClick={() => setAddForm({ ...addForm, name: shift })}
                  >
                    {shift}
                  </button>
                ))}
              </div>
            </div>
            <div className="schedule-mng-field">
              <span className="form-label">Время</span>
              <div className="schedule-mng-time">
                <label>
                  С
                  <input
                    type="text"
                    className="form-control"
                    inputMode="numeric"
                    placeholder="10"
                    value={addForm.start}
                    onChange={(e) =>
                      setAddForm({ ...addForm, start: Number(e.target.value) })
                    }
                  />
                </label>
                <span>→</span>
                <label>
                  До
                  <input
                    type="text"
                    className="form-control"
                    inputMode="numeric"
                    placeholder="18"
                    value={addForm.end}
                    onChange={(e) =>
                      setAddForm({ ...addForm, end: Number(e.target.value) })
                    }
                  />
                </label>
              </div>
              {lunchPreview != null ? (
                <p className="schedule-mng-hours-preview">
                  {formatMngHours(duration - lunchPreview, 2)} ч после обеда · обед{" "}
                  {formatMngHours(lunchPreview, 2)} ч
                </p>
              ) : null}
            </div>
          </>
        )}

        <div className="schedule-mng-field">
          <span className="form-label">Период</span>
          <div className="schedule-mng-range">
            <label>
              С
              <input
                id="mng-shift-start-date"
                type="date"
                className="form-control"
                value={addForm.date}
                onChange={(event) => {
                  const nextStart = event.target.value;
                  setAddForm({
                    ...addForm,
                    date: nextStart,
                    endDate:
                      !addForm.endDate || addForm.endDate < nextStart
                        ? nextStart
                        : addForm.endDate,
                  });
                }}
              />
            </label>
            <span>→</span>
            <label>
              По
              <input
                id="mng-shift-end-date"
                type="date"
                className="form-control"
                min={addForm.date}
                value={endDate}
                onChange={(event) =>
                  setAddForm({ ...addForm, endDate: event.target.value })
                }
              />
            </label>
          </div>
          <div className="schedule-mng-range-presets">
            {[1, 3, 7, 14].map((days) => (
              <button
                key={days}
                type="button"
                className={`schedule-mng-range-chip${
                  preview.total === days ? " is-active" : ""
                }`}
                onClick={() => setRangeDays(days)}
              >
                {days === 1 ? "1 день" : `${days} дн.`}
              </button>
            ))}
            <button
              type="button"
              className="schedule-mng-range-chip"
              onClick={setRangeToMonthEnd}
            >
              До конца месяца
            </button>
          </div>
          {preview.total > 1 ? (
            <div className="schedule-mng-preview">
              <div>
                <strong>{toCreate}</strong>
                <span>проставим</span>
              </div>
              <div>
                <strong>{preview.busy}</strong>
                <span>заняты</span>
              </div>
              <div>
                <strong>{preview.past}</strong>
                <span>прошлые</span>
              </div>
            </div>
          ) : null}
        </div>
        {infoMessage ? (
          <div className="schedule-mng-modal-message">{infoMessage}</div>
        ) : null}
      </>
    );
  };

  async function loadAppored(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingApprove) return;
    setIsLoadingApprove(true);
    try {
      const data = await GetApprove(token, from, to);
      setDataApprove(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingApprove(false);
    }
  }

  const fillCurrentMonth = () => {
    if (!arrayDate[0]) return;
    setDownloadStart(arrayDate[0]);
    setDownloadEnd(arrayDate.at(-1) || arrayDate[0]);
    setDownloadMessage(null);
  };

  async function download() {
    if (Number(accessLevelUser) < MNGLevel) return;
    if (!downloadStart || !downloadEnd) {
      setDownloadMessage({ ok: false, text: "Выберите период" });
      return;
    }
    if (downloadStart > downloadEnd) {
      setDownloadMessage({ ok: false, text: "Начало периода позже конца" });
      return;
    }
    setDownloading(true);
    setDownloadMessage(null);
    try {
      const response = await GetReportMNG(token, downloadStart, downloadEnd);
      const blob =
        response?.data instanceof Blob
          ? response.data
          : response instanceof Blob
            ? response
            : null;
      if (!blob || blob.size === 0) {
        const payload = response && !(response.data instanceof Blob) ? response : null;
        setDownloadMessage({
          ok: false,
          text: errorText(payload, "Не удалось скачать отчёт"),
        });
        return;
      }
      if (blob.type && blob.type.includes("json")) {
        try {
          const payload = JSON.parse(await blob.text());
          setDownloadMessage({
            ok: false,
            text: errorText(payload, "Нет доступа к отчёту"),
          });
        } catch (err) {
          console.error(err);
          setDownloadMessage({ ok: false, text: "Не удалось скачать отчёт" });
        }
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response?.headers?.["content-disposition"];
      let filename = `расписание_мнг_${downloadStart}_${downloadEnd}.xlsx`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (match?.[1]) filename = match[1];
      }
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setDownloadMessage({ ok: true, text: "Файл скачан" });
    } catch (err) {
      console.error(err);
      setDownloadMessage({ ok: false, text: "Не удалось скачать отчёт" });
    } finally {
      setDownloading(false);
    }
  }

  const renderLoading = () => (
    <div className="schedule-chk-loading">
      <div className="spinner-border" style={{ color: "#fd0429" }} role="status">
        <span className="visually-hidden">Загрузка...</span>
      </div>
      <p>Загрузка расписания...</p>
    </div>
  );

  const monthRangeLabel =
    arrayDate[0] && arrayDate.at(-1)
      ? `${formatShortDate(arrayDate[0])} — ${formatShortDate(arrayDate.at(-1))}`
      : "";
  const monthName = arrayDate[0]
    ? new Date(arrayDate[0]).toLocaleDateString("ru-RU", {
        month: "long",
        year: "numeric",
      })
    : "";
  const canDownload = Number(accessLevelUser) >= MNGLevel;
  const canBulkDelete = MngGroupLevels.includes(Number(accessLevelUser));
  const selectedCount = Object.keys(selectedShifts).length;

  return (
    <div className="schedule-chk-page schedule-mng-page">
      <div className="schedule-chk-toolbar">
        <div>
          <h1>Расписание МНГ</h1>
          <p className="schedule-chk-hint">
            Выберите любой день месяца — загрузится график с первого по последнее
            число
          </p>
        </div>
        <div className="schedule-chk-toolbar-right">
          <div className="schedule-chk-week-picker">
            <label className="schedule-chk-week-label" htmlFor="mng-month-date">
              Месяц
            </label>
            <input
              id="mng-month-date"
              type="date"
              className="form-control"
              value={monthPickerDate}
              onChange={selectDate}
            />
            <span className="schedule-chk-week-range">
              {monthRangeLabel}
              {monthName ? ` · ${monthName}` : ""}
            </span>
          </div>
          <Link to="/profile" className="schedule-chk-back-link">
            ← К профилю
          </Link>
        </div>
      </div>

      <div className="schedule-chk-tabs-wrap">
        <ul className="nav nav-tabs schedule-chk-tabs">
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "schedule" ? "active" : ""}`}
              onClick={() => switchTab("schedule")}
            >
              Расписание
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "approve" ? "active" : ""}`}
              onClick={() => switchTab("approve")}
            >
              Согласование
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "more" ? "active" : ""}`}
              onClick={() => switchTab("more")}
            >
              Прочее
            </button>
          </li>
        </ul>
      </div>

      <div className="schedule-chk-panel">
        {activeTab === "schedule" && (
          <>
            {isLoadingSchedule ? (
              renderLoading()
            ) : !tableSchedule?.table ? (
              <div className="schedule-chk-empty">
                Нет данных за выбранный месяц
              </div>
            ) : (
              <>
                <div className="schedule-mng-rules">
                  <strong>Правила составления графика</strong>
                  <ol>
                    <li>
                      Не более 5 смен подряд. 6-я и дальше подсвечиваются красной
                      обводкой — это совет, сохранять можно.
                    </li>
                    <li>
                      У каждого сотрудника должен быть непрерывный отдых минимум
                      42 часа в неделю. Это примерно как 2 выходных подряд.
                    </li>
                    <li>
                      Промежуток между сменами не менее 12 часов. Если меньше —
                      обе смены подсвечиваются, сохранять можно.
                    </li>
                  </ol>
                </div>
                <div className="schedule-chk-legend">
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--off" />
                    Выходной
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-shift" />
                    МС
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-mr" />
                    МР
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-admin" />
                    Админ
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-pipl" />
                    Пипл
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-inven" />
                    Инвен
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-trip" />
                    Командировка
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-meeting" />
                    Собрание
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-office" />
                    Офис
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-other" />
                    В другом ресторане
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--mng-status" />
                    Отпуск, больничный и статусы
                  </span>
                </div>
                <div
                  className={`schedule-mng-workspace${
                    selectMode ? " is-selecting" : ""
                  }`}
                >
                  {canBulkDelete ? (
                    <div
                      className={`schedule-mng-select-bar${
                        selectMode ? " is-active" : ""
                      }`}
                    >
                      <div className="schedule-mng-select-copy">
                        <strong>
                          {selectMode
                            ? selectedCount
                              ? `Выбрано ${selectedCount}`
                              : "Выделите смены"
                            : "Несколько смен"}
                        </strong>
                        <p>
                          {selectMode
                            ? "Клик по смене — выбрать. По дате или ФИО — все доступные. Прошедшие даты не берутся."
                            : "Включите выделение, отметьте ячейки и удалите сразу несколько смен."}
                        </p>
                      </div>
                      <div className="schedule-mng-select-actions">
                        {selectMode ? (
                          <>
                            <button
                              type="button"
                              className="schedule-chk-week-tool-btn"
                              onClick={clearSelection}
                              disabled={selectedCount === 0}
                            >
                              Снять
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => setConfirmBulkDelete(true)}
                              disabled={selectedCount === 0 || bulkDeleting}
                            >
                              Удалить
                              {selectedCount ? ` ${selectedCount}` : ""}
                            </button>
                            <button
                              type="button"
                              className="schedule-chk-week-tool-btn"
                              onClick={toggleSelectMode}
                            >
                              Готово
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="btn"
                            onClick={toggleSelectMode}
                          >
                            Выделить
                          </button>
                        )}
                      </div>
                      {bulkMessage ? (
                        <p
                          className={`schedule-mng-select-message ${
                            bulkMessage.ok ? "is-ok" : "is-error"
                          }`}
                        >
                          {bulkMessage.text}
                        </p>
                      ) : null}
                    </div>
                  ) : null}
                  {renderScheduleTable()}
                  {confirmBulkDelete ? (
                    <div className="schedule-chk-week-modal">
                      <div className="schedule-chk-week-modal-card">
                        <h5>Удалить выбранные смены?</h5>
                        <p>
                          Будет удалено {selectedCount}{" "}
                          {selectedCount === 1 ? "смена" : "смен"}. Прошедшие
                          даты сервер пропустит.
                        </p>
                        <div className="schedule-chk-week-modal-actions">
                          <button
                            type="button"
                            className="schedule-chk-week-tool-btn"
                            onClick={() => setConfirmBulkDelete(false)}
                            disabled={bulkDeleting}
                          >
                            Отмена
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={deleteSelectedShifts}
                            disabled={bulkDeleting}
                          >
                            {bulkDeleting ? "Удаление…" : "Удалить"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <p className="schedule-chk-hint mt-2 mb-0">
                  «—» в ячейке — выходной: в этот день смены нет. В ячейке —
                  часы смены без обеда (4 мин за час) и факт по отметкам.
                  Справа: план, факт, норма и норма + обеды. Итог часов
                  округляется вверх до десятых.
                </p>
                <ScheduleMNGChart
                  schedule={tableSchedule}
                  selectedDate={selectedDate}
                />
                <ScheduleMNGHours
                  schedule={tableSchedule}
                  normaHours={normaHours}
                />
              </>
            )}
          </>
        )}

        {activeTab === "approve" && (
          <>
            {isLoadingApprove ? (
              renderLoading()
            ) : !Number.isFinite(dataApprove?.id) ? (
              <div className="schedule-chk-empty">
                Нет данных о согласовании за выбранный месяц
              </div>
            ) : (
              <ScheduleChkApprove
                data={dataApprove}
                weekDates={arrayDate}
                accessLevel={accessLevelUser}
                token={token}
                onUpdated={setDataApprove}
                approveRequest={Approve}
                period="month"
              />
            )}
          </>
        )}

        {activeTab === "more" && (
          <div className="chk-more schedule-mng-more">
            <section className="chk-more-card chk-more-download">
              <div className="chk-more-card-head">
                <h4>Скачать расписание</h4>
                <p>Excel по своему ресторану за выбранный период.</p>
              </div>
              {!canDownload ? (
                <p className="chk-more-readonly">
                  Скачивание доступно с уровня MNG.
                </p>
              ) : (
                <>
                  <div className="chk-more-download-fields">
                    <div className="chk-more-download-field">
                      <label className="form-label" htmlFor="mng-download-start">
                        Начало
                      </label>
                      <input
                        id="mng-download-start"
                        type="date"
                        className="form-control"
                        value={downloadStart}
                        onChange={(event) => setDownloadStart(event.target.value)}
                      />
                    </div>
                    <div className="chk-more-download-field">
                      <label className="form-label" htmlFor="mng-download-end">
                        Конец
                      </label>
                      <input
                        id="mng-download-end"
                        type="date"
                        className="form-control"
                        value={downloadEnd}
                        onChange={(event) => setDownloadEnd(event.target.value)}
                      />
                    </div>
                    <button
                      type="button"
                      className="schedule-chk-week-tool-btn chk-more-download-week"
                      onClick={fillCurrentMonth}
                    >
                      Текущий месяц
                    </button>
                  </div>
                  <div className="chk-more-card-footer">
                    {downloadMessage ? (
                      <span className={downloadMessage.ok ? "is-ok" : "is-error"}>
                        {downloadMessage.text}
                      </span>
                    ) : (
                      <span className="chk-more-footer-hint">
                        {arrayDate[0]
                          ? `По умолчанию ${formatShortDate(arrayDate[0])} — ${formatShortDate(arrayDate.at(-1))}`
                          : "Выберите период"}
                      </span>
                    )}
                    <button
                      type="button"
                      className="btn"
                      onClick={download}
                      disabled={downloading}
                    >
                      {downloading ? "Скачивание…" : "Скачать xlsx"}
                    </button>
                  </div>
                </>
              )}
            </section>
          </div>
        )}
      </div>

      <div
        className="modal fade modal-schedule-chk-day schedule-mng-modal"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered schedule-mng-create-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <p className="schedule-mng-modal-kicker">
                  {haveShiftOrNo ? "Расписание МНГ" : "Новая запись"}
                </p>
                <h5 className="modal-title" id="staticBackdropLabel">
                  {haveShiftOrNo
                    ? "Смена"
                    : Number(addForm.typeShiftId) > 1
                      ? "Статус на период"
                      : "Смена"}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              />
            </div>
            <div className="modal-body">
              {haveShiftOrNo ? (
                renderModalHaveShift(deleteForm.shift)
              ) : (
                <>
                  {renderCreateShiftContext()}
                  {renderAddShiftForm()}
                </>
              )}
            </div>
            <div className="modal-footer">
              {haveShiftOrNo ? (
                <>
                  {infoMessage ? (
                    <div className="schedule-mng-modal-message">
                      {infoMessage}
                    </div>
                  ) : null}
                  <button
                    type="button"
                    className="schedule-chk-week-tool-btn"
                    data-bs-dismiss="modal"
                  >
                    Закрыть
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={deleteShift}
                  >
                    Удалить
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="schedule-chk-week-tool-btn"
                    data-bs-dismiss="modal"
                  >
                    Отмена
                  </button>
                  <button
                    type="button"
                    className="btn"
                    onClick={createShift}
                    disabled={creating}
                  >
                    {getCreateButtonLabel()}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleMNG;

function getFormattedMonthDates(inputDate) {
  const date = new Date(inputDate);

  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return [formatDate(firstDay), formatDate(lastDay)];
}

const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function toIsoDate(value) {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  try {
    return formatDate(new Date(value));
  } catch (err) {
    return "";
  }
}

function parseIso(iso) {
  if (!iso) return null;
  const [year, month, day] = String(iso).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return null;
  return { year, month: month - 1, day };
}

function addDaysIso(iso, days) {
  const parsed = parseIso(iso);
  if (!parsed) return iso;
  const date = new Date(parsed.year, parsed.month, parsed.day);
  date.setDate(date.getDate() + days);
  return formatDate(date);
}

function eachIsoDate(startIso, endIso) {
  const start = parseIso(startIso);
  const end = parseIso(endIso);
  if (!start || !end) return [];
  const dates = [];
  const cursor = new Date(start.year, start.month, start.day);
  const last = new Date(end.year, end.month, end.day);
  if (last < cursor) return [];
  while (cursor <= last) {
    dates.push(formatDate(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return dates;
}

function todayLocalIso() {
  return formatDate(new Date());
}

function formatMngDisplayDate(dateString) {
  if (!dateString) return "—";
  const date = new Date(dateString);
  const weekdays = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year} (${weekdays[date.getDay()]})`;
}

function formatShortDate(dateString) {
  if (!dateString) return "";
  const iso = String(dateString).slice(0, 10);
  const [, month, day] = iso.split("-");
  return day && month ? `${day}.${month}` : iso;
}

function errorText(payload, fallback) {
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  if (typeof payload.detail === "string") return payload.detail;
  if (Array.isArray(payload.detail) && payload.detail[0]?.msg) {
    return payload.detail[0].msg;
  }
  return fallback;
}
